import { render, staticRenderFns } from "./RevenueComparison.vue?vue&type=template&id=658f827e"
import script from "./RevenueComparison.vue?vue&type=script&lang=js"
export * from "./RevenueComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports